import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authReducer from 'features/auth/authSlice';
import { baseApi } from './services/baseApi';
import { rtkQueryErrorLogger } from './middleware';
import documentReducer from 'features/document/documentSlice';
import salesforceReducer from 'features/salesforce/salesforceSlice';
import organizationReducer from 'features/organization/organizationSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  document: documentReducer,
  salesforce: salesforceReducer,
  organization: organizationReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat([baseApi.middleware, rtkQueryErrorLogger]),
});

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
